export default __webpack_public_path__ + "06fe0370adcff7928dfe92e3b31d24af.png";